import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { FeatureHelperService } from '../../../../_helpers/feature-helper/feature-helper.service';
import { ErrorModalHelperService } from '../../../../_helpers/error-modal-helper/error-modal-helper.service';
import { SuccessModalHelperService } from '../../../../_helpers/success-modal-helper/success-modal-helper.service';
import { MilestoneService } from '../../../../_services/milestone/milestone.service';
import { MilestoneEventSection } from '../../../../_models/timeline-models/section-models/milestone-event-section.model';
import { DynamicConfirmModalComponent } from '../../../../shared/dynamic-confirm-modal/dynamic-confirm-modal.component';

/**
 * Displays a learner milestone event on the timeline (event date, description, creator). Delete is
 * available to consultants only (hasFeature('IndividualLearningReportsApprove')); the server enforces
 * nothing, so this is the only gate. No edit/lifecycle — milestones are create-from-card, delete-here.
 */
@Component({
  selector: 'milestone-event-section',
  templateUrl: './milestone-event-section.component.html',
  standalone: false,
})
export class MilestoneEventSectionComponent extends BaseLearningSectionComponent {

  @Input() timelineSection = new MilestoneEventSection();

  constructor(
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    private featureHelperService: FeatureHelperService,
    private milestoneService: MilestoneService,
    private errorModalHelper: ErrorModalHelperService,
    private successModalHelper: SuccessModalHelperService,
  ) {
    super(flowHelperService, dialog);
    this.sectionTitle = 'Milestone event';
  }

  public canDelete(): boolean {
    return this.featureHelperService.hasFeature('IndividualLearningReportsApprove');
  }

  public confirmDelete(): void {
    if (!this.canDelete()) return;
    const confirmRef = this.dialog.open(DynamicConfirmModalComponent, {
      data: { confirmMessage: 'This will permanently remove this milestone event, are you sure you wish to continue?' },
      panelClass: 'my-confirm-dialog'
    });
    confirmRef.afterClosed().subscribe((confirm: boolean) => {
      if (confirm) this.delete();
    });
  }

  public delete(dialogRef?: MatDialogRef<any>): void {
    this.milestoneService.deleteById(this.timelineSection.id).subscribe({
      next: () => {
        this.successModalHelper.show('Milestone event deleted');
        this.reloadRequested.next();
      },
      error: (error) => this.errorModalHelper.show(error.message, error),
    });
  }
}
